import React, { useContext } from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { convertToInternationalCurrencySystem } from "../../helper";
import { StateContext } from "../../store/context";
import { mergeBarChartOptions } from "../../pages/Compare/chartTheme";

const RevenueCurrenctVsPast: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};
  const { baseCurrency } = useContext(StateContext);

  const chartData: any = {
    options: mergeBarChartOptions({
      chart: {
        id: "RevenueCurrentVsPast",
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return `${baseCurrency} ${convertToInternationalCurrencySystem(
              String(value)
            )}`;
          },
        },
      },
      xaxis: {
        categories,
      },
      tooltip: {
        shared: true,
        intersect: false,
        hideEmptySeries: false,
      },
      dataLabels: {
        formatter: (value: string) => {
          return convertToInternationalCurrencySystem(value);
        },
        enabled: true,
        offsetY: -20,
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Revenue: Current-vs-Past (Quartely)</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default RevenueCurrenctVsPast;
